<template>
  <div>
    <div class="base-input ovf-hd conmon-top" style="margin-bottom: 10px;">
      <el-collapse-transition>
        <div class="search-content common-search-formtype" style="line-height: 60px">
          <div class="demo-input-suffix" style="text-align: left;margin-left: 32px">
            公众号切换：
            <el-select v-model="original_id" placeholder="请选择" @change='getData()'>
              <el-option v-for="item in publicNumber" :key="item.original_id" :label="item.nick_name"
                :value="item.original_id">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">默认回复</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div">
        <el-form :model="formInline" label-width="100px" class="box-content-form">
          <p class="reply-title">用户发消息时，默认回复的内容</p>
          <ul class="Reply-content Reply">
            <li @click="replyText = true">
              <img src="../../assets/images/1.png" alt="">
            </li>
            <li @click="replyMarketing = true">
              <img src="../../assets/images/2.png" alt="">
            </li>
            <li @click="replyPicture = true">
              <img src="../../assets/images/3.png" alt="">
            </li>
            <li @click="replyPage = true">
              <img src="../../assets/images/4.png" alt="">
            </li>
            <!-- <li @click="replyModules = true">
              <img src="../../assets/images/6.png" alt="">
            </li> -->
          </ul>
          <el-form-item :label="ReplyTit" v-if='ReplyCon' style='text-align: left;margin-left: 300px'>
            <span style="text-align:left;display: inline-block;width: 100%;" v-if='type != 13'>{{ReplyContent}}</span>
            <img :src="replypic" style="width:100px" v-if='type == 13'>
          </el-form-item>
          <el-form-item label="" style="text-align: left;width: 100%;margin-top: 93px">
            <el-button v-if="butsObj.del" class="second-page-btn-back reply-btn-type reply-btn-type-delete"
              style="float: none; margin-left: 234px;margin-right:32px;" @click='delReplyApi'>删除</el-button>
            <el-button v-if="butsObj.save" class="second-page-btn reply-btn-type" type="primary" style="float: none;"
              @click='editKeywordApi'>保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <!-- 关键词弹窗 -->
    <el-dialog class="cellDialog" title="添加回复文字" :visible.sync="replyText" width="30%">
      <el-input type="textarea" :rows="5" placeholder="请输入回复文字" v-model="text">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyText = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="ReplyTrue('显示文字:',text,1)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 微营销回复 -->
    <el-dialog class="cellDialog" title="选择微营销" :visible.sync="replyMarketing" width="500px">
      <el-select v-model="reply_id" filterable placeholder="可输入查询微营销" style="width: 280px">
        <el-option v-for="item in marketingList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyMarketing = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="ReplyTrue('弹出微营销:',reply_id,6)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片回复 -->
    <el-dialog class="cellDialog" title="上传图片" :visible.sync="replyPicture" width="500px">
      <el-upload class="reply-avatar-uploader-icon" list-type="picture-card" :show-file-list="false" :action="upload"
        name="file_upload" :before-upload="beforeAvatarUpload" :on-success="thumbSuccess">
        <div v-if="replypic" class="opacity-div">
          <img :src="replypic" class="interest-image">
          <div class="back-div">点击更换</div>
        </div>
        <div v-if="replypic === ''" slot="tip" style="line-height:20px;color:#606266; margin-top: 10px;">
          请选择1M以下，支持上传jpg/png文件</div>
        <img v-if="replypic === ''" src="../../assets/images/Group.png" class="default-images">
      </el-upload>
      <!-- <p>必填！建议尺寸250x140</p> -->
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyPicture = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="ReplyTrue('显示图片:',replypic,13)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 微页面回复 -->
    <el-dialog class="cellDialog" title="选择微页面" :visible.sync="replyPage" width="500px">
      <el-select v-model="page_reply_id" filterable placeholder="可输入查询微页面" style="width: 280px">
        <el-option v-for="item in MicroPage" :key="item.id" :label="item.admin_title" :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyPage = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="ReplyTrue('弹出微页面:',page_reply_id,14)">确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 模块回复 -->
    <el-dialog class="cellDialog" title="选择模块" :visible.sync="replyModules" width="500px">
      <el-select v-model="module_reply_id" filterable placeholder="可输入查询模块" style="width: 280px">
        <el-option v-for="item in modules" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="replyModules = false">取 消</el-button>
        <el-button type="primary" class="dialog-confirm-btn" @click="ReplyTrue('回复:',module_reply_id,module_reply_id)">确
          定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { butonsList, getMenId } from '@/api/analyse.js'
import { WePagesList, getReplyDetail, getReplyDel, delReplyApi, ActivityList } from '@/api/customer.js'
export default {
  name: 'ReplyKeyWordAdd',
  data () {
    return {
      hasTrue: true,
      publicNumber: [],
      original_id: '',
      formInline: {
        keyword: ''
      },
      modules: [
        // {id: 15, name: '会员注册'},
        { id: 16, name: '线下活动' }
      ],
      module_reply_id: '',
      replyModules: false, // 回复模块
      replyText: false, // 回复弹窗--文字
      replyMarketing: false, // 营销
      replyPicture: false, // 图片
      replyPage: false, // 微页面
      MicroPage: [], // 微页面列表
      marketingList: [], // 微营销列表
      type: null,
      text: '',
      replypic: '',
      imgName: '',
      API_HOST: API_HOST,
      reply_id: '',
      page_reply_id: '',
      ReplyCon: false,
      ReplyTit: '',
      ReplyContent: '',
      butsObj: { // button按钮列表
        save: false,
        del: false
      }
    }
  },
  computed: {
    upload () {
      // console.log(window.HOST)
      return API_HOST + '/admin/Upload/upload'
    }
  },
  mounted () {
    rule.publicNumber((res) => {
      for (let item of res.data.data.list) {
        if (item.is_disable === 0) {
          this.publicNumber.push(item)
        }
        if (item.is_default === 1) {
          this.public_id = item.id
          this.original_id = item.original_id
        }
      }
      this.microListApi()
      this.marketingListApi()
    })
    this.getReplyDetail()
    this.getButtonsList()
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    beforeAvatarUpload (file) {
      _g.toastMsg('success', '正在上传')
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        _g.toastMsg('上传图片只能是 JPG/PNG 格式!')
      }
      return (isJPG) || (isPNG)
    },
    getData () {
      for (let item of this.publicNumber) {
        if (item.original_id == this.original_id) {
          this.public_id = item.id
          this.microListApi()
          this.marketingListApi()
        }
      }
      this.getReplyDetail()
    },
    // 微营销
    marketingListApi () {
      let data = {
        search: {
          public_id: this.public_id,
          status: 1
        }
      }
      ActivityList(data).then((res) => {
        if (res.data.code === 0) {
          this.marketingList = res.data.data.list
          this.totalMa = res.data.data.total
          let flag = 0
          this.marketingList.some(item => {
            if (item.id !== this.reply_id) {
              flag++
            }
            if (flag === this.marketingList.length) {
              this.reply_id = ''
            }
          })
        }
      })
    },
    // 微页面
    microListApi () {
      let data = {
        search: {
          public_id: this.public_id,
          publish_status: 1
        }
      }
      WePagesList(data).then((res) => {
        if (res.data.code === 0) {
          for (let item of res.data.data.list) {
            item.id = item.id + ''
          }
          this.MicroPage = res.data.data.list
          let flag = 0
          this.MicroPage.some(item => {
            if (item.id !== this.reply_id) {
              flag++
            }
            if (flag === this.MicroPage.length) {
              this.page_reply_id = ''
            }
          })
        }
      })
    },
    // 获取详情
    getReplyDetail () {
      this.text = ''
      this.reply_id = ''
      this.page_reply_id = ''
      this.replypic = ''
      let data = {
        original_id: this.original_id,
        msgtype: 2
      }
      getReplyDetail(data).then((res) => {
        if (res.data.code === 0) {
          if (res.data.data.info.type === 0) {
            this.hasTrue = false
          } else {
            this.hasTrue = true
          }
          console.log(res)
          let info = res.data.data.info
          let replydata = res.data.data.replydata
          this.formInline.keyword = info.keyword
          if (info.type === 1) {
            this.ReplyTrue('显示文字:', replydata.text, 1)
            this.text = replydata.text
          } else if (info.type === 6) {
            this.ReplyTrue('弹出微营销:', replydata.title, info.type, 1)
            this.reply_id = replydata.lottery_id
          } else if (info.type === 13) {
            this.ReplyTrue('显示图片:', replydata.picture, info.type)
          } else if (info.type === 14) {
            this.ReplyTrue('弹出微页面:', replydata.title, info.type, 1)
            this.page_reply_id = replydata.scene_id
          } else if (info.type === 15) {
            this.ReplyTrue('回复:', '会员注册', info.type)
          } else if (info.type === 16) {
            this.ReplyTrue('回复:', '线下活动', info.type)
          } else {
            this.ReplyCon = false
          }
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    thumbSuccess (response, file, fileList) {
      this.replypic = response.data.path
      this.imgName = file.name
    },
    // 添加和编辑
    editKeywordApi () {
      let data = {
        original_id: this.original_id,
        type: this.type,
        keyword: this.formInline.keyword,
        msgtype: 2
      }
      if (this.type === 1) {
        data.text = this.text
      } else if (this.type === 6) {
        data.reply_id = this.reply_id
        data.lottery_type = 'l'
      } else if (this.type === 13) {
        data.img = this.imgName
        data.picture = this.replypic
      } else if (this.type === 14) {
        data.reply_id = this.page_reply_id
      }
      getReplyDel(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res)
          _g.toastMsg('success', '保存成功')
          this.getReplyDetail()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    delReplyApi () {
      let data = {
        original_id: this.original_id,
        msgtype: 2
      }
      delReplyApi(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res)
          _g.toastMsg('success', '删除成功')
          this.formInline.keyword = ''
          this.text = ''
          this.reply_id = ''
          this.page_reply_id = ''
          this.imgName = ''
          this.replypic = ''
          this.type = null
          this.getReplyDetail()
        } else {
          if (!this.hasTrue) {
            _g.toastMsg('error', '未保存无法删除')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        }
      })
    },
    ReplyTrue (title, con, type, status) {
      if (type === 15) {
        con = '会员注册'
      }
      if (type == 16) {
        con = '线下活动'
      }
      // console.log(type)
      if (status === 1) {
        if (type === 13) {
          this.replypic = con
        } else {
          this.ReplyContent = con
        }
      } else {
        if (type === 14) { // 微页面
          if (con === '') {
            _g.toastMsg('error', '请选择微页面')
            return
          }
          for (let item of this.MicroPage) {
            if (item.id == con) {
              this.ReplyContent = item.admin_title
            }
          }
        } else if (type === 6) { // 微营销
          if (con === '') {
            _g.toastMsg('error', '请选择微营销')
            return
          }
          for (let item of this.marketingList) {
            if (item.id == con) {
              this.ReplyContent = item.name
            }
          }
        } else if (type === 13) { // 显示图片
          if (con === '') {
            _g.toastMsg('error', '请上传图片')
            return
          }
          this.replypic = con
        } else if (type === 1) { // 文字
          if (con === '') {
            _g.toastMsg('error', '请输入回复文字')
            return
          }
          this.ReplyContent = con
        } else {
          if (con === '') {
            _g.toastMsg('error', '请选择模块')
            return
          }
          this.ReplyContent = con
        }
      }
      this.type = type
      this.ReplyTit = title
      this.ReplyCon = true
      this.replyText = false // 回复弹窗--文字
      this.replyMarketing = false // 营销
      this.replyPicture = false // 图片
      this.replyPage = false
      this.replyModules = false
    }
  },
  created () {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #e4e4e4;
  height: 60px;
  padding: 10px;
  line-height: 40px;
  margin-top: 10px;
}
.green {
  color: green;
}
.red {
  color: red;
}
.add-btn {
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content {
  width: calc(100% - 50px);
  margin: 0 auto;
}
.box-content-div {
  width: 800px;
  margin: auto;
}
.box-content-form {
  margin-top: 10px;
  text-align: center;
}
.box-content-form .el-form-item {
  width: 300px;
}
.Reply-content {
  height: 130px;
  padding-left: 0px;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
}
.Reply-content li {
  width: 130px;
  height: 130px;
  /*margin-right: 20px;*/
  border-radius: 5px;
  /*float: left;*/
  list-style: none;
  cursor: pointer;
  margin-bottom: 20px;
}
.Reply-content li i {
  font-size: 40px;
  margin: 20px 0 8px 0;
}
.Reply-content li span {
  display: block;
  font-size: 14px;
}
.Reply-content li:hover {
  color: #ff9b00;
}
.replyMarketing {
  position: relative;
  top: -20px;
  height: 292px;
  text-align: left;
  padding-left: 20px;
}
.page {
  position: absolute;
  bottom: -51px;
  right: 0;
}
.search-flod-content {
  border: 1px solid #ebebeb;
}
.avatar-uploader-icon {
  width: 148px;
  line-height: 148px;
}
.replyMarketing .el-radio {
  width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.interest-image {
  display: inline-block;
  width: 148px;
  height: 148px;
  position: relative;
}
.opacity-div {
  width: 148px;
  height: 148px;
  position: relative;
}
.opacity-div:hover .back-div {
  opacity: 1 !important;
}
.back-div {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  height: 148px;
  width: 148px;
  top: 0px;
  left: 1px;
  opacity: 0;
  cursor: pointer;
  color: #fff;
  line-height: 148px;
}
.default-images {
  width: 148px;
}
.interest-uploader {
  width: 148px;
  height: 148px;
}
</style>
